import { render, staticRenderFns } from "./group.vue?vue&type=template&id=7aedfb39"
import script from "./group.vue?vue&type=script&lang=tsx"
export * from "./group.vue?vue&type=script&lang=tsx"
import style0 from "./group.vue?vue&type=style&index=0&id=7aedfb39&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports